import { Link } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'react-oidc-context';

import { ErrorSection } from 'src/components/sections/ErrorSection';
import { Button } from 'src/components/ui/button';
import { BrandSidebarWithHeader } from 'src/layouts/BrandSidebarWithHeader';
import { FullWidthConstrainedLayout } from 'src/layouts/FullWidthConstrainedLayout';
import { ForecastDefaultRoute } from 'src/routes/forecast';

export function ForbiddenPage(): ReactElement {
  const auth = useAuth();
  const { t } = useTranslation('errors');

  const content = (
    <ErrorSection
      action={
        <Button>
          <Link to={auth?.user ? ForecastDefaultRoute.to : '/'}>
            {t('Go back home')}
          </Link>
        </Button>
      }
      code={403}
      description={t('You are not authorized to access this page')}
      title={t('Forbidden')}
    />
  );

  return auth?.user ? (
    <BrandSidebarWithHeader>{content}</BrandSidebarWithHeader>
  ) : (
    <div className='flex h-screen w-screen overflow-hidden'>
      <div className='flex grow flex-col overflow-y-auto'>
        <FullWidthConstrainedLayout>{content}</FullWidthConstrainedLayout>
      </div>
    </div>
  );
}
